import React from 'react'
import isArray from 'lodash/isArray'
import groupBy from 'lodash/groupBy'
import { format } from './datetime'

export const removeFilter = ({ initialFilter, filter, payload }) => {
    /*
     * Sample payload:
     * Removable filter should be passed as either of the following formats.
     * As a string / Array of strings / Object with filter key and value
     * 'date', ['date', 'dateFrom', 'dateTo'], { tag: 'tag1' }
     */

    if (typeof payload === 'string') {
        return { ...filter, [payload]: initialFilter[payload] }
    }
    if (isArray(payload)) {
        const temp = { ...filter }
        payload.forEach(c => {
            if (temp.hasOwnProperty(c)) temp[c] = initialFilter[c]
        })
        return temp
    }
    if (!isArray(payload)) {
        const temp = { ...filter }
        for (const key in payload) {
            if (Object.hasOwnProperty.call(payload, key)) {
                const element = payload[key]
                if (typeof element === 'string' && typeof temp[key] === 'object') {
                    temp[key] = temp[key].filter(e => e !== element)
                }
            }
        }
        return temp
    }

    return true
}

export const generatePatientFilterPills = (filter, { dateOptions, tagOptions }) => {
    if (!filter) return []

    const ret = []
    if (dateOptions && filter.date) {
        ret.push({
            name: 'date',
            val: filter.date,
            label: 'Examination date',
            value:
                filter.date !== 'custom'
                    ? dateOptions.find(f => f.value === filter.date).label
                    : `${format(filter.dateFrom, 'dd.MM.yyyy')} - ${format(
                          filter.dateTo,
                          'dd.MM.yyyy'
                      )}`,
        })
    }
    if (tagOptions?.length && filter.tag) {
        tagOptions = [{ label: 'All', value: 'all' }, ...tagOptions]
        ret.push({
            name: 'tag',
            label: filter.tag.length === 1 ? 'Tag' : 'Tags',
            value: filter.tag.map(ft => {
                return { key: tagOptions.find(t => t.value === ft)?.label, val: ft }
            }),
        })
    }
    return ret
}

export const generateFilter = data => {
    if (!data) return

    const filterArray = [
        {
            key: 'date',
            filterBy: 'ExamDate',
            range: true,
        },
        {
            key: 'tag',
            filterBy: 'Tags',
        },
        {
            key: 'shared',
            filterBy: 'HasOnlySharedFile',
        },
    ]
    const temp = []

    data.forEach(d => {
        for (const key in d) {
            if (Object.hasOwnProperty.call(d, key)) {
                const element = d[key]
                const finder = filterArray.find(fa => fa.key === key)
                if (finder) {
                    if (typeof element === 'string' && element !== '') {
                        const c = `${finder.filterBy}=eq:"${element}"`
                        temp.push(c)
                    }
                    if (isArray(element)) {
                        let c = []
                        if (finder.range) {
                            c = [
                                `${finder.filterBy}=ge:"${element[0]}"`,
                                `${finder.filterBy}=le:"${element[1]}"`,
                            ]
                        } else {
                            c = element.map(e => {
                                return `${finder.filterBy}=${e}`
                            })
                        }
                        temp.push(...c)
                    }
                }
            }
        }
    })
    return temp
}

export const generateSort = (sortKey, array = null) => {
    const sortArray = array || [
        {
            key: 'dateDesc',
            sortBy: 'examDate',
            orderDesc: true,
        },
        {
            key: 'dateAsc',
            sortBy: 'examDate',
            orderDesc: false,
        },
        {
            key: 'az',
            sortBy: 'patientname',
            orderDesc: false,
        },
        {
            key: 'za',
            sortBy: 'patientname',
            orderDesc: true,
        },
    ]
    let temp = []

    const finder = sortArray.find(sa => sa.key === sortKey)
    if (finder) {
        temp = [`Sort.By=${finder.sortBy}&Sort.Desc=${finder.orderDesc}`]
    }
    return temp
}

export const generateQuery = params => {
    return params
        .map(p => p.value)
        .flat()
        .join('&')
}

export const highlightText = (string, searchText) => {
    const subStringArray = string.split(
        new RegExp(
            '(?<first>' + searchText.replace(/[/(]/g, '\\(').replace(/[/)]/g, '\\)') + ')',
            'i'
        )
    )
    return subStringArray.map((text, index) => (
        <React.Fragment key={index}>
            {text.toLowerCase() === searchText.toLowerCase() ? <mark>{text}</mark> : text}
        </React.Fragment>
    ))
}

export const getSummaryFromFiles = (selected, list, summary, op = false) => {
    const selFiles = list.filter(f => selected.includes(f.fileId))
    const grouped = groupBy(selFiles, f => f.fileType)
    const image = grouped.image?.length || 0
    const video = grouped.video?.length || 0

    const delSummary = { all: image + video, image, video }
    const newSummary = {}

    for (const key in summary) {
        if (Object.hasOwnProperty.call(summary, key)) {
            newSummary[key] = op ? summary[key] + delSummary[key] : summary[key] - delSummary[key]
        }
    }
    return newSummary
}
